export default "__VITE_ASSET__CtRQwRns__"